module.exports = __webpack_public_path__ + "img/goods04.2928a7d1.jpg";